export class AnalyticsAdjustPagesModel {
    criarconta_perfil_tudocerto = '';
    criarconta_dados_documento_numero = '';
    criarconta_dados_documento = '';
    criarconta_renda_residenciafiscal = '';
}
